// 即將開始下一篇
import Image from "next/image";

const Upcoming = ({ t }) => {
  return (
    <div className="mx-auto mt-[65px] text-center">
      <span className="text-bd1n text-black inline-block mb-[8px]">
        {t("UPCOMING")}
      </span>
      <Image
        className="dark:filter-white mx-auto"
        width={20}
        height={20}
        src="/images/icon/icon_upcoming.svg"
        alt="upcoming"
      />
    </div>
  );
};

export default Upcoming;
